import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { Chords } from './../context';
import Sadko from '../service/Sadko';
import withTune from './hocs/withTune';

const ChordName = styled.span`
    padding: 0;
    color: #662f0a;
`;

function InlineChord({ name, tune, fireOnRender = true }) {
    const { dispatch } = useContext(Chords.Context);
    const transposedName = Sadko.transposeNoteByTune(name, tune);

    useEffect(() => {
        if (fireOnRender && transposedName) {
            dispatch({ type: Chords.actions.PUSH, name: transposedName })
        }
    }, [fireOnRender, transposedName, dispatch]);

    return <ChordName>{transposedName}</ChordName>
}

export default React.memo(withTune(InlineChord));
